<template>
  <div>
    <button class="btn" v-on:click="page = 1" v-if="page > 1" title="First page">
      <icon :icon="['fad', 'angle-double-left']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <button class="btn disabled" disabled v-else>
      <icon :icon="['fad', 'angle-double-left']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <button class="btn" v-on:click="page--" v-if="page > 1" title="Previous page">
      <icon :icon="['fad', 'angle-left']"/>
    </button>
    <button class="btn disabled" disabled v-else>
      <icon :icon="['fad', 'angle-left']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <span>{{page}} / {{numPages}}</span>
    <button class="btn" v-on:click="page++" v-if="page < numPages" title="Next page">
      <icon :icon="['fad', 'angle-right']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <button class="btn disabled" disabled v-else>
      <icon :icon="['fad', 'angle-right']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <button class="btn" v-on:click="page = numPages" v-if="page < numPages" title="Last page">
      <icon :icon="['fad', 'angle-double-right']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
    <button class="btn disabled" disabled v-else>
      <icon :icon="['fad', 'angle-double-right']" v-bind:class="{ 'fa-2x': isMobile()}"/>
    </button>
  </div>
</template>
<script>
  export default {
    name: 'ViewControlls',
    props: {
      numPages: {},
      page: {},
      bindclass: ''
    }
  }
</script>
